function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import classnames from 'classnames';

/**
 * Category: FormElements
 *
 * The layout of a form is created by nesting `form__row` and `form__column`.
 * Inside each column you add the components you need for creating your own form.
 *
 * More form examples on the <a href="/forms">forms sample page</a>.
 */
var Form = function Form(_ref) {
  var id = _ref.id,
    action = _ref.action,
    method = _ref.method,
    onSubmit = _ref.onSubmit,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("form", {
    id: id,
    className: classnames('form', _defineProperty({}, className, className)),
    action: action,
    method: method,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "form__fieldset"
  }, children));
};
var FormRow = function FormRow(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "form__row"
  }, children);
};
var FormColumn = function FormColumn(_ref3) {
  var size = _ref3.size,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "form__column ".concat(size ? 'form__column--' + size : '')
  }, children);
};
var FormSuccessMessage = function FormSuccessMessage(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "form__success"
  }, children);
};
Form.FormRow = FormRow;
Form.FormColumn = FormColumn;
Form.FormSuccessMessage = FormSuccessMessage;
export default Form;